import ProtectedRoute from './ProtecetedRoute';

export default ProtectedRoute;
